import { makeVar } from '@apollo/client';

/** Increment to re-fetch GQL context and re-sync Amplitude account user properties. */
export const analyticsAccountUserPropertiesRefreshVar = makeVar(0);

export const requestAnalyticsAccountUserPropertiesRefresh = (): void => {
  analyticsAccountUserPropertiesRefreshVar(analyticsAccountUserPropertiesRefreshVar() + 1);
};
